import axios from 'axios'
import config from './config'

var api = {
    //获取配置地址
    getBaseUrl() {
        return config.baseURL;
    },
    // -----------------------------用户--------------------------------------
    // 登录
    login(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/login/login', {}, config);
    },
    logout() {
        return axios.get('/login/logout', config);
    },
    //用户修改个人密码
    updatePassword(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/user/accountAudit', {}, config);
    },
    //获取所有菜单权限
    getAllMenuRights(obj) {
        config.params = obj;
        return axios.get('/privilege/privilegeAll', config);
    },
    //获取区域树形菜单
    getRegionTree(obj) {
        config.params = obj;
        return axios.get('/deparment/findTreeDeparts', config);
    },
    //根据区域获取用户列表(分页)
    getUserListByDp(obj) {
        config.params = obj;
        return axios.get('/user/UserByDepartmentPage', config);
    },
    //根据区域获取用户列表(不分页)
    getUserListByDp2(obj) {
        config.params = obj;
        return axios.get('/user/UserByDepartment', config);
    },
    //添加用户
    addUser(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/user/saveUser', {}, config);
    },
    //编辑用户
    editeUser(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/user/UserInfo', {}, config);
    },
    //删除角色
    deleteUser(obj) {
        config.params = obj;
        return axios.delete('/user/User', config);
    },
    //获取角色列表/不分页
    getRoleList2(obj) {
        config.params = obj;
        return axios.get('/role/roleAll', config);
    },
    //获取角色列表/分页
    getRoleList(obj) {
        config.params = obj;
        return axios.get('/role/roleAllPage', config);
    },
    //添加角色
    addRole(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/role/saveRole', {}, config);
    },
    //编辑角色
    editeRole(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/role/updateRole', {}, config);
    },
    //删除角色
    deleteRole(obj) {
        config.params = obj;
        return axios.delete('/role/delRole', config);
    },
    //管理员重置用户密码
    resetPassword(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/user/resetPassword', {}, config);
    },
    //获取车辆信息管理页面列表数据(分页)
    getCarInforList(obj) {
        config.params = obj;
        return axios.get('/carInformation/carAll', config);
    },
    //在线离线、限定区域
    getNowDataCarsInfHttpPost(obj) {
        config.params = obj;
        return axios.get('/OBDData/nowDataCarsInfHttpPost', config);
    },
    //在用车预警列表信息分页
    getZycWaringListPageStatistic(obj) {
        config.params = obj;
        return axios.get('/homepage2/zycWaringListPageStatistic', config);
    },
    //车辆信息管理导入excle
    importCarInforData(obj) {
        config.params = {};
        config.data = obj;
        return axios.post('/file/importCarsInfoToExcel', {}, config);
    },
    //车辆信息管理导出excle
    exportCarInforData(obj) {
        config.params = obj;
        return axios.get('/file/exportCarsInfoToExcel', config);
    },
    //添加车辆信息
    addCarInfor(obj, userId) {
        config.data = obj;
        config.params = {};
        return axios.post('/carInformation/saveCars', {userId: userId}, config);
    },
    //编辑车辆信息
    editeCarInfor(obj, userId) {
        config.data = obj;
        config.params = {};
        return axios.put('/carInformation/carAlter', {userId: userId}, config);
    },
    //删除车辆信息
    deleteCarInfor(obj) {
        config.params = obj;
        return axios.delete('/carInformation/delCarId', config);
    },
    //获取车辆信息管理左侧属性列表数据
    getRegionTreeList(obj) {
        config.params = obj;
        return axios.get('/deparment/findTreeDepartsCountingCarAmount', config);
    },
    //燃料加注页面菜单树查询
    getRegionTreeListFuel(obj) {
        config.params = obj;
        return axios.get('/deparment/findTreeDepartsCountingCar', config);
    },
    //获取省级区域列表
    getProvincialList(obj) {
        config.params = obj;
        return axios.get('/deparment/findSeDepartmentByUser', config);
    },
    //获取市级区域列表
    getCityList(obj) {
        config.params = obj;
        return axios.get('/deparment/findSiDepartmentByUser', config);
    },
    //获取县级区域列表
    getCountyList(obj) {
        config.params = obj;
        return axios.get('/deparment/findXDepartmentByUser', config);
    },
    //获取车辆归属地列表(分页)
    getCarDeparmentList(obj) {
        config.params = obj;
        return axios.get('/deparment/findDepPageByIdName', config);
    },
    //添加车辆归属地
    addCarDeparment(obj, userId) {
        config.data = obj;
        config.params = {};
        return axios.post('/deparment/saveDeparts', {userId: userId}, config);
    },
    //删除车辆归属地
    deleteCarDeparment(obj) {
        config.params = obj;
        return axios.delete('/deparment/delDeparts', config);
    },
    //获取车辆类型列表(分页)
    getCarTypeList(obj) {
        config.params = obj;
        return axios.get('/carUseType/carTypeAll', config);
    },
    //获取产品类型
    getProductionTypeList(obj) {
        config.params = obj;
        return axios.get('/carInformation/productionTypeList', config);
    },
    //获取发送信息内容模板(分页)
    getSendMessage(obj) {
        config.params = obj;
        return axios.get('/DcSendMessage/findDcSendMessage', config);
    },
    //获取告警信息列表
    getWarnItemList(obj) {
        config.params = obj;
        return axios.get('/warninginformation/getWarningItemMap', config);
    },
    //添加车辆类型
    addCarType(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/carUseType/saveCarType', {}, config);
    },
    //编辑车辆类型
    editeCarType(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/carUseType/carType', {}, config);
    },
    //删除车辆类型
    deleteCarType(obj) {
        config.params = obj;
        return axios.delete('/carUseType/delCarTypeId', config);
    },
    //获取车辆用途列表(分页)
    getCarUseTypeList(obj) {
        config.params = obj;
        return axios.get('/carUseType/carUseAll', config);
    },
    //添加车辆用途
    addCarUseType(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/carUseType/saveCarUse', {}, config);
    },
    //编辑车辆用途
    editeCarUseType(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/carUseType/carUse', {}, config);
    },
    //删除车辆用途
    deleteCarUseType(obj) {
        config.params = obj;
        return axios.delete('/carUseType/delCarUse', config);
    },
    //获取公告列表(分页)
    getNoticeList(obj) {
        config.params = obj;
        return axios.get('/notice/UserNoticeAll', config);
    },
    //发布公告
    addNotice(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/notice/saveNotice', {}, config);
    },
    //新增预警模板
    saveDcSendMessage(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/DcSendMessage/saveDcSendMessage', {}, config);
    },
    //修改预警模板
    updateDcSendMessage(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/DcSendMessage/updateDcSendMessage', {}, config);
    },
    //删除预警模板
    delDcSendMessage(obj) {
        config.params = obj;
        return axios.delete('/DcSendMessage/delDcSendMessage', config);
    },
    //编辑公告
    editeNotice(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/notice/updateNotice', {}, config);
    },
    //删除公告
    deleteNotice(obj) {
        config.params = obj;
        return axios.delete('/notice/deleteNotice', config);
    },
    //获取在用车实时数据(分页)
    getInUseCarRealTimeData(obj) {
        config.params = obj;
        return axios.get('/zycData/zycNowDataHttpPost1', config);
    },
    //获取在用车历史数据(分页)
    getInUseCarHistoryData(obj) {
        config.params = obj;
        return axios.get('/zycData/zycHistoryDataHttpPost', config);
    },
    //获取在用车警告值数据(分页)
    getInUseCarAlarmData(obj) {
        config.params = obj;
        return axios.get('/zycData/zycWarningDataHttpPost', config);
    },
    //获取在用车警告值
    getInUseCarAlarmNum(obj) {
        config.params = obj;
        return axios.get('/zycData/zycWarningDatas', config);
    },
    //设定在用车告警值
    setInUseCarAlarmData(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/zycData/setZycWarningDatas', {}, config);
    },
    //获取OBD实时数据(分页)
    getMonitorRealTimeData(obj) {
        config.params = obj;
        return axios.get('/OBDData/obdNowDataHttpPost', config);
    },
    //
    getMonitorOnlineData(obj) {
        config.params = obj;
        return axios.get('/OBDData/obdDataAnalyse', config);
    },
    getInUserOnlineData(obj) {
        config.params = obj;
        return axios.get('/zycData/zycDataAnalyse', config);
    },

    //获取在用车历史数据(分页)
    getMonitorHistoryData(obj) {
        config.params = obj;
        return axios.get('/OBDData/obdHistoryDataHttpPost', config);
    },
    //地图定位里获取车辆列表
    getCarPositionData(obj) {
        config.params = obj;
        return axios.get('/map/mapLocationHttpPost', config);
    },
    //获取区域ID获取车辆列表(全景地图)
    getAllViewData(obj) {
        config.params = obj;
        return axios.get('/map/mapLocationAllHttpPost', config);
    },
    //获取所有车辆升级信息
    getCarUpgradeInfor(obj) {
        config.params = obj;
        return axios.get('/carUpgradeInformation/carUpgradeAll', config);
    },
    //批量升级
    carBatchUpgrade(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/carUpgradeInformation/carUpdateSoft', {}, config);
    },
    //获取车辆轨迹回放数据
    getCarTrackReplayData(obj) {
        config.params = obj;
        return axios.get('/map/trackPlaybackHttpPost', config);
    },
    //获取燃料或尿素数据
    getFuelOrUreaData(obj) {
        config.params = obj;
        return axios.get('/fuelurea/findFuelOrUrea', config);
    },
    //获取监控数据查询条件数据
    getMonitorSelectionList(obj) {
        config.params = obj;
        return axios.get('/statistical/findSelect', config);
    },
    getMonitorSelectionList1(obj) {
        config.params = obj;
        return axios.get('/statistical/findSelect1', config);
    },
    getSendMessageList(obj) {
        config.params = obj;
        return axios.get('/DcSendMessage/findDcSendMessageList', config);
    },
    sendMessage(obj) {
        config.params = obj;
        return axios.get('/DcSendMessage/dcSendMessage', config);
    },
    sendMessageInfo(obj) {
        config.params = obj;
        return axios.get('/DcSendMessage/sendMessageInfo', config);
    },
    //获取监控数据查询数据
    getMonitorSearchResult(obj) {
        config.params = obj;
        return axios.get('/statistical/findExceptDepartmentId', config);
    },
    //根据区域id和条件获取关联下拉条件列表
    getCarLinkList(obj) {
        config.params = obj;
        return axios.get('/statistical/findInformationCarLinkage', config);
    },
    //获取区域数据查询数据
    getRegionSearchResult(obj) {
        config.params = obj;
        return axios.get('/statistical/findStatisByDepartmentId', config);
    },
    //获取单车数据统计项目下拉框
    getSingleCarSelectionList(obj) {
        config.params = obj;
        return axios.get('/statistics/getObdItemMap', config);
    },
    //获取区域数据查询数据
    getSingleCarSearchResult(obj) {
        config.params = obj;
        return axios.get('/statistics/obdHistoryStatistics', config);
    },
    //首页区域车辆数量统计（柱状图）
    getHomepageCarAmount(obj) {
        config.params = obj;
        return axios.get('/homepage/departmentCarAmount', config);
    },
    //首页OBD排放统计接口（饼状图)
    getHomepageLetAmount(obj) {
        config.params = obj;
        return axios.get('/homepage/carLetAmount', config);
    },
    //首页终端在线离线统计（饼状图）
    getHomepageCarOnline(obj) {
        config.params = obj;
        return axios.get('/homepage/carOnlineOffline', config);
    },
    //首页在用车告警数量统计（饼状图）
    getHomepageCarWarnAmount(obj) {
        config.params = obj;
        return axios.get('/homepage/zycWarningCarAmount', config);
    },
    //在用车nox分析
    getNoxStatisticsResult(obj) {
        config.params = obj;
        return axios.get('/zycData/noxStatistics', config);
    },
    //首页在用车与OBD车辆数量比例统计（饼状图）
    getHomepageOBDAndInuseCar(obj) {
        config.params = obj;
        return axios.get('/homepage/zycObdAmount', config);
    },
    //首页中国地图全景展示（概况地区车辆分布图）
    getHomeChinaMap(obj) {
        config.params = obj;
        return axios.get('/homepage/seDepartmentCarAmount', config);
    },
    //获取预警信息列表
    getWarningInforList(obj) {
        config.params = obj;
        return axios.get('/warninginformation/findCarWarningInformation', config);
    },
    //查询预警信息列表（短信发送页面）
    getWarningInformationList(obj) {
        config.params = obj;
        return axios.get('/warninginformation/findWarningInformation', config);
    },
    //首页电子围栏预警
    getElectronicFenceWarningStatistic(obj) {
        config.params = obj;
        return axios.get('/warninginformation/getElectronicFenceWarningStatistic', config);
    },
    //获取在用车预警信息列表
    getWarningCarInforList(obj) {
        config.params = obj;
        return axios.get('/warninginformation/findCarWarningCarInformation', config);
    },
    //获取电子围栏列表
    getElectronicFenceList(obj) {
        config.params = obj;
        return axios.get('/fence/findFenceByUser', config);
    },
    //查看电子围栏详情
    getElectronicFenceDetail(obj) {
        config.params = obj;
        return axios.get('/fence/findFenceById', config);
    },
    //添加电子围栏
    addElectronicFence(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/fence/saveFence', {}, config);
    },
    //删除电子围栏
    deleteElectronicFence(obj) {
        config.params = obj;
        return axios.delete('/fence/deleteFenceById', config);
    },


//首页在用车告警前5
    getZycWaringListStatistic(obj) {
        config.params = obj;
        return axios.get('/homepage2/zycWaringListStatistic', config);
    },

//首页OBD告警前5
    getObdWaringListStatistic(obj) {
        config.params = obj;
        return axios.get('/homepage2/obdWaringListStatistic', config);
    },

    //首页在用车OBD限定区域车辆数量统计（饼状图）
    getHomepage2AreaCarAmountStatistic(obj) {
        config.params = obj;
        return axios.get('/homepage2/areaCarAmountStatistic', config);
    },
    //首页在用车终端在线离线统计（饼状图）
    getHomepage2ZycOnline(obj) {
        config.params = obj;
        return axios.get('/homepage2/zycOnlineOffline', config);
    },
    //首页OBD终端在线离线统计（饼状图）
    getHomepage2ObdOnline(obj) {
        config.params = obj;
        return axios.get('/homepage2/obdOnlineOffline', config);
    },
    //首页在用车地图定位及参数信息
    getHomepage2ZycMap(obj) {
        config.params = obj;
        return axios.get('/homepage2/zycMapInfo', config);
    },
    //首页在用车预警信息统计
    getZycWaringInfoStatistic(obj) {
        config.params = obj;
        return axios.get('/homepage2/zycWaringInfoStatistic', config);
    },
    //首页OBD在用车地图定位及参数信息
    getHomepage2ObdMap(obj) {
        config.params = obj;
        return axios.get('/homepage2/obdMapInfo', config);
    },
    //首页监控数据预警数量统计（柱状图）
    getHomepage2LetAmount(obj) {
        config.params = obj;
        return axios.get('/homepage2/carLetAmount', config);
    },
    //首页近半年维修车辆统计20190727
    getMaintain() {
        return axios.get('/carFaultMaintain/mationStatistic', config);
    },
    //获取车辆定位和电子围栏数据
    getCarPositionAndFenceData(obj) {
        config.params = obj;
        return axios.get('/warninginformation/findCarWarningFenceInfo', config);
    },
    //获取车辆故障类型列表(分页)
    getCarFaultTypeList(obj) {
        config.params = obj;
        return axios.get('/carUseType/carFaultTypeAll', config);
    },
    //添加车辆故障
    addCarFaultType(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/carUseType/saveCarFaultType', {}, config);
    },
    //编辑车辆用途
    editeCarFaultType(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/carUseType/updateCarFaultType', {}, config);
    },
    //删除车辆用途
    deleteCarFaultType(obj) {
        config.params = obj;
        return axios.delete('/carUseType/delCarFaultType', config);
    },
    //获取车辆信息管理页面列表数据(分页)
    getCarFaultMaintainList(obj) {
        config.params = obj;
        return axios.get('/carFaultMaintain/carFaultMaintainList', config);
    },
    //获取车辆信息管理页面列表数据(分页)
    addFaultMaintain(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/carFaultMaintain/saveFaultMaintain', {}, config);
    },
    //获取车辆牌集合
    getCarNumList(obj) {
        config.params = obj;
        return axios.get('/carInformation/carAll', config);
    },
    //修改故障维修记录
    editeFaultMaintain(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/carFaultMaintain/faultMaintainAlter', {}, config);
    },
    //故障维修记录废弃
    deleteFaultMaintain(obj) {
        config.params = obj;
        return axios.delete('/carFaultMaintain/updateSolveStatus', config);
    },
    //获得车辆所有类型统计
    getVehicleTypeStatistics(obj) {
        config.params = obj;
        return axios.get('/carInformation/getCarTypeStatistics', config);
    },
    //获得告警车辆所有类型统计
    getCarWarningTypeStatistics(obj) {
        config.params = obj;
        return axios.get('/carInformation/getCarWarningTypeStatistics', config);
    },

    //获取obd实时数据(带状污染分析)
    getMonitorRealTimeMapData(obj) {
        config.params = obj;
        return axios.get('/dataAnalysis/obdNowDataHttpPost', config);
    },
    //获取tObdNox实时数据(分页)
    getObdNoxCalculationTimeData(obj) {
        config.params = obj;
        return axios.get('/dataAnalysis/emissionCalculation', config);
    },
    getHalfYearNoxStatistical(obj){
        config.params=obj;
        return axios.get('/carFaultMaintain/getSixNoxStatistical',config)
    },
    getMessageLogInfo(obj){
        config.params=obj;
        return axios.get('/messageLog/queryMessageLogs',config)
    },
    delMessageLog(obj){
        config.params=obj;
        return axios.delete('/messageLog/delMessageLog',config)
    },
    pushNotice(obj) {
        config.params=obj;
        return axios.get('/DcSendMessage/pushNotice',config)
    },
    //获取点位信息列表
    getPointList(obj){
        config.params=obj;
        return axios.get('/pointInfo/pageFindPoint',config)
    },
    //新增点位
    addPoint(obj) {
        config.data = obj;
        config.params = {};
        return axios.post('/pointInfo/savePoint', {}, config);
    },
    //删除点位
    deletePoint(obj) {
        config.params = obj;
        return axios.delete('/pointInfo/delPoint', config);
    },
    findAllPointType(){

        return axios.get('/pointInfo/findDcPointType',config)
    },
    //编辑公告
    editePoint(obj) {
        config.data = obj;
        config.params = {};
        return axios.put('/pointInfo/updatePoint', {}, config);
    },
    //获取obd车辆历史数据统计
    getObdHistoryAnalyse(obj) {
        config.params = obj;
        return axios.get('/historyAnalyse/obdList', config);
    },
    batchDownload(url) {
        return axios.get(url,{timeout: 600000})
    }
}

export default api



// WEBPACK FOOTER //
// ./src/api/API.js